import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThirdpartyDisclosuresComponent } from './thirdparty-disclosures.component';
@NgModule({
    imports: [CommonModule],
    declarations: [ThirdpartyDisclosuresComponent],
    exports: [ThirdpartyDisclosuresComponent],
})
export class ThirdpartyDisclosuresModule {}
